const AMAP_KEY = process.env.VUE_APP_AMAP_KEY || 'c49c4cf73481b811438018f743725c03'
const AMAP_SECURITY_CODE =
  process.env.VUE_APP_AMAP_SECURITY_CODE || '593bd0991d17f0c644d6359cf7faaf14'
const AMAP_SCRIPT_ID = 'amap-js-sdk'

export function hasAmapKey() {
  return Boolean(AMAP_KEY)
}

export function loadAmap() {
  if (window.AMap) {
    return Promise.resolve(window.AMap)
  }

  if (!AMAP_KEY) {
    return Promise.reject(new Error('missing-key'))
  }

  if (window.__amapLoadPromise) {
    return window.__amapLoadPromise
  }

  if (AMAP_SECURITY_CODE) {
    window._AMapSecurityConfig = {
      securityJsCode: AMAP_SECURITY_CODE
    }
  }

  window.__amapLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(AMAP_SCRIPT_ID)

    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.AMap), {
        once: true
      })
      existingScript.addEventListener(
        'error',
        () => reject(new Error('script-load-failed')),
        { once: true }
      )
      return
    }

    const script = document.createElement('script')
    script.id = AMAP_SCRIPT_ID
    script.async = true
    script.src = 'https://webapi.amap.com/maps?v=2.0&key=' + encodeURIComponent(AMAP_KEY)

    script.onload = () => {
      if (window.AMap) {
        resolve(window.AMap)
        return
      }

      reject(new Error('amap-not-available'))
    }

    script.onerror = () => {
      reject(new Error('script-load-failed'))
    }

    document.head.appendChild(script)
  })

  return window.__amapLoadPromise
}

export function loadAmapPlugins(plugins) {
  return loadAmap().then(AMap => {
    if (!plugins || plugins.length === 0) {
      return AMap
    }

    return new Promise((resolve, reject) => {
      try {
        AMap.plugin(plugins, () => resolve(AMap))
      } catch (error) {
        reject(error)
      }
    })
  })
}
